/**
 *
 * ExpiredTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.charcoalDark};
    background: ${COLORS.charcoalLight};
    border-color: ${COLORS.charcoal};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.charcoal};
    }
  }
`;

function ExpiredTag(props) {
  return <StyledTag label="Expired" icon={<PinTripIcon />} {...props} />;
}

export default memo(ExpiredTag);
